import * as action from './action'

export const LoginAction = Object.assign({}, action);